<template>
  <div class="form-check form-switch" :class="groupClass">

    <input type="checkbox" role="switch" class="form-check-input"
           :id="id"
           :value="modelValue"
           @change="updateValue($event)"
           :required="required"
           :disabled="disabled"
           :checked="modelValue">

    <label class="form-check-label" :for="id" v-html="label"></label>

    <div class="error text-danger" v-if="validationErrors" v-for="error in validationErrors">
      <div>{{ error.$message }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {ErrorObject} from "@vuelidate/core";

export default defineComponent({
  name: "GroupSwitch",
  emits: ['update:modelValue', 'keyup'],
  props: {
    id: String,
    name: String,
    modelValue: Boolean,
    required: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    type: {type: String, default: 'text'},
    label: String,
    validation: Object,
    validationErrors: Object as PropType<ErrorObject[]>,
    groupClass: {type: String, default: 'form-check form-switch'}
  },
  methods: {
    updateValue(e: Event) {
      this.$emit('update:modelValue', (<HTMLInputElement>e.target).checked)
    }
  },
})
</script>

<style scoped>
</style>
